module.exports = __webpack_public_path__ + "static/entrance-door-67c6c7a94b2c3d74d022c0abcf8f6424.png";